"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedIcon = exports.SpinnerIcon = exports.SuccessIcon = exports.OrderStatusProgressBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const Icons_1 = require("./Icons");
Object.defineProperty(exports, "SuccessIcon", { enumerable: true, get: function () { return Icons_1.SuccessIcon; } });
Object.defineProperty(exports, "FailedIcon", { enumerable: true, get: function () { return Icons_1.FailedIcon; } });
Object.defineProperty(exports, "SpinnerIcon", { enumerable: true, get: function () { return Icons_1.SpinnerIcon; } });
const hooks_1 = require("../../shared/hooks");
const getThirdIcon = (status, isMobile) => {
    if (status === "success") {
        return (0, jsx_runtime_1.jsx)(Icons_1.SuccessIcon, { isMobile: isMobile }, void 0);
    }
    return status === "in-progress" ? ((0, jsx_runtime_1.jsx)(Icons_1.SpinnerIcon, { isMobile: isMobile }, void 0)) : ((0, jsx_runtime_1.jsx)(Icons_1.FailedIcon, { isMobile: isMobile }, void 0));
};
// TODO: grid should simplify
const OrderStatusProgressBar = ({ labels, status }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { status: status, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Icons_1.SuccessIcon, { isMobile: isMobile }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: labels[0] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Icons_1.SuccessIcon, { isMobile: isMobile }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: labels[1] }, void 0)] }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { children: [getThirdIcon(status, isMobile), (0, jsx_runtime_1.jsx)(typography_1.P, { children: labels[2] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [status !== "success" ? ((0, jsx_runtime_1.jsx)(Icons_1.UnknownIcon, { isMobile: isMobile }, void 0)) : ((0, jsx_runtime_1.jsx)(Icons_1.SuccessIcon, { isMobile: isMobile }, void 0)), (0, jsx_runtime_1.jsx)(typography_1.P, { children: labels[3] }, void 0)] }, void 0)] }, void 0)] }, void 0));
};
exports.OrderStatusProgressBar = OrderStatusProgressBar;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;

  &::before {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.greyLighten70};
    content: "";
    display: inline-block;
    position: absolute;
    top: 8px;
    left: 3.5rem;
    width: calc(100% - 7rem);
    z-index: 1;
  }

  p {
    margin: ${({ theme }) => `${theme.spacings.xs} 0 0`};
  }

  & > div {
    z-index: 10;
  }

  & > div:first-of-type,
  & > div:last-of-type {
    display: flex;
    justify-content: space-between;
  }

  & > div:first-of-type {
    & > div:first-of-type > div {
      margin-left: 3rem;
    }

    & > div:last-of-type {
      text-align: end;

      p {
        transform: translateX(40%);
      }
    }
  }

  & > div:last-of-type {
    & > div:first-of-type {
      p {
        transform: translateX(-40%);
      }
    }

    & > div:last-of-type {
      text-align: end;

      span,
      & > div {
        margin-right: 3rem;
      }

      p {
        color: ${({ theme, status }) => status !== "success" ? theme.colors.greyLighten70 : "inherit"};
      }
    }
  }

  & > div:first-of-type {
    width: calc(100% / 3 + 1.75rem);
  }

  & > div:nth-of-type(2) {
    width: calc(100% / 3 - 3rem);
  }

  & > div:last-of-type {
    width: calc(100% / 3 + 1.75rem);
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    &::before {
      left: 0.5rem;
      width: calc(100% - 1rem);
    }

    div > p {
      display: none;
    }

    & > div:first-of-type > div:first-of-type > *:first-child {
      margin-left: 0;
    }

    & > div:last-of-type > div:last-of-type span,
    & > div:last-of-type > div:last-of-type > div {
      margin-right: 0;
    }

    & > div:first-of-type {
      width: calc(100% / 3 + 2rem);
    }

    & > div:nth-of-type(2) {
      width: calc(100% / 3);
    }

    & > div:last-of-type {
      width: calc(100% / 3 + 2rem);
    }
  }
`;
//# sourceMappingURL=index.js.map